import { Component, OnInit,Input,ViewChild } from '@angular/core';
import { ModalesComponent } from "./modales/modales.component";
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { trigger,transition,style,animate } from "@angular/animations";
import {TranslateService} from '@ngx-translate/core';
import { SurveyStatusV2Service } from "../../survey-status-v2.service";
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
const moment = require('moment');
const momentTz = require('moment-timezone');
import * as $ from 'jquery';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
import * as backInter from 'app/auth/auth-data.model';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { MatSnackBar } from "@angular/material/snack-bar";
import { zonasUTC } from 'app/main/pagina/zonasUtc';
export interface PeriodicElement {
  aviso1: number;
  status: String;
  icon: String;
  aviso2: number;
  invitacion: number;
  recor1: number;
  recor2: number;
}
export interface PeriodicElement2 {
  aviso1: number;
  nombre: String;
  aviso2: number;
  invitacion: number;
  recor1: number;
  recor2: number;
}
const ELEMENT_DATA: PeriodicElement[] = [
  {icon:'mark_email_read', status: 'enviados', aviso1: 0, aviso2: 0, invitacion: 0,recor1: 0,recor2: 0},
  {icon:'forward_to_inbox',status: 'procesando', aviso1: 0, aviso2: 0, invitacion: 0,recor1: 0,recor2: 0},
  {icon:'unsubscribe',status: 'error', aviso1: 0, aviso2: 0, invitacion: 0,recor1: 0,recor2: 0},

];
const ELEMENT_DATAS: PeriodicElement2[] = [
  {nombre: 'Daniel', aviso1: 0, aviso2: 0, invitacion: 0,recor1: 0,recor2: 0},
  {nombre: 'Lucy', aviso1: 0, aviso2: 0, invitacion: 0,recor1: 0,recor2: 0},
  {nombre: 'Aarón', aviso1: 0, aviso2: 0, invitacion: 0,recor1: 0,recor2: 0},
  {nombre: 'Andres', aviso1: 0, aviso2: 0, invitacion: 0,recor1: 0,recor2: 0},
  {nombre: 'Juancho', aviso1: 0, aviso2: 0, invitacion: 0,recor1: 0,recor2: 0},
  {nombre: 'Paco', aviso1: 0, aviso2: 0, invitacion: 0,recor1: 0,recor2: 0},

];

@Component({
  selector: 'vizualizador-emails',
  templateUrl: './vizualizador-emails.component.html',
  styleUrls: ['./vizualizador-emails.component.scss']
})
export class VizualizadorEmailsComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  displayedColumns: string[] = ['objeto', 'aviso1', 'aviso2', 'invitacion','recor1','recor2'];
  displayedColumns2: string[] = ['colaborador', 'aviso1', 'aviso2', 'invitacion','recordatorio1','recordatorio2'];
  displayedColumns3: string[] = ['Event','UserName','EMail','SendDateTime', 'TotalEnvios', 'accion'];

  totalEmailsColaboradores:any
  dataSource = ELEMENT_DATA;
  dataSource2 = ELEMENT_DATAS;
  datosEmpresaProducto: any = {};
  datosGlobalsEmails: any;
isAnimate: true;
@Input() infoEmpresaProducto: Observable<any>;
@Input() consultarEmailLog: Observable<any>;
tituloCabezeraEmails:string="";
datosTablaTipoCorreo:any;
datosTablaTipoCorreoInfo:any;
  cargando:number=0;
  tipoCorreoBuscar:number;
  statusCorreoBuscar:string;
  typeIconStatus:string;
  colorIconStatus:string;
  getLogPrimVez: boolean;
  idiomaActual:string;
  offsetPipe: string;
  diferenciaUtc: number;
  zonasUTC = zonasUTC;
  indiceZona: number;
  instUtc: number;
  instituto: string;
  dataAllGlobalEmailStatus:any;
  constructor(
    public dialog: MatDialog,
    private translateSrv: TranslateService,
    private surveyServ: SurveyStatusV2Service,
    private wizardService: WizardService,
    private snackBar: MatSnackBar,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
  }

  ngOnInit(): void {
    // console.log('this.dataSource',this.dataSource);


    this.infoEmpresaProducto.subscribe((datos:any) => {
      for(let prop in datos){
        this.datosEmpresaProducto[prop] = datos[prop];
      }
      // console.log("datosEmpresaLogMails:",this.datosEmpresaProducto);
      if(this.datosEmpresaProducto.datosProducto && !this.getLogPrimVez){
        this.getLogPrimVez = true;
        if(this.datosEmpresaProducto.tipoProducto != 3){
          // console.log("El producto No es norma 35");
          // this.getHistoryEmailsColab(this.datosEmpresaProducto.idProducto);
          this.obtieneInstituto()
      }else{
        // console.log("El producto es norma 35");
      }
      }
    });

    this.consultarEmailLog.subscribe((datos:any)=>{
      if (datos==true) {
        console.log('si jalo chido ');
        if (this.dataAllGlobalEmailStatus==undefined) {
          console.log('si jalo chido por primera vez');
          this.modalEnviandoCorreos();
          this.getAllGlobalsEmailStatus(this.datosEmpresaProducto.idProducto,1);
        }
      }
    })

  }

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; this.instUtc = 1;  break;
      case '2': case 'CAyC': this.instituto = 'CAyC'; this.instUtc = 2;   break;
      case '3': case 'HK': this.instituto = 'HK'; this.instUtc = 3;break;
      case '4': case 'SGP': this.instituto = 'WLDWDE'; this.instUtc = 4;  break;
      case '5': case 'TK': this.instituto = 'TK'; this.instUtc = 5;break;
      case '6': case 'FL': this.instituto = 'WLDWDE'; this.instUtc = 6;  break;
      case '11': case 'BR': this.instituto = 'WLDWDE'; this.instUtc = 11;  break;
      case '14': case 'GCTI': this.instituto = 'GCTI'; this.instUtc = 1;  break;
      case '15': case 'ES': this.instituto = 'WLDWDE'; this.instUtc = 15;  break;
      case '18': case 'AMCO': this.instituto = 'AMCO'; this.instUtc = 18;  break;
      case '19':  this.instituto = 'INNMOTION'; this.instUtc = 19;  break;
      default: this.instituto = 'WLDWDE';
    }
     // console.log('this.instUtc',this.instUtc);

    this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == this.instUtc);
    console.log('this.indiceZona',this.indiceZona);

    this.calculoOffsetPipe();
  }
  calculoOffsetPipe(){
    console.log('this.datosEmpresaProducto.indiceZona',this.datosEmpresaProducto.indiceZona);

    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.datosEmpresaProducto.indiceZona].zona).format()).utcOffset();
    // console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    // console.log("offsetPipe:",this.offsetPipe);
  }

  // getHistoryEmailsColab(idProdcto){
  //   console.log('idProdcto',idProdcto);
  //     this.surveyServ.getHistoryEmailColab(idProdcto).subscribe((respuesta:any) => {
  //       console.log("getHistoryEmailColab:",respuesta);
  //       this.totalEmailsColaboradores = new MatTableDataSource<any>(respuesta.totalEmailsColaboradores);
  //     });
  //
  //   }

  getAllGlobalsEmailStatus(idProdcto,tipo){

    // console.log('idProdcto',idProdcto);
    // console.log('tipo',tipo);
      this.surveyServ.getAllGlobalEmailStatus(idProdcto).subscribe((respuesta:any) => {
        console.log("getAllGlobalEmailStatus:",respuesta);
        if (respuesta.success==true) {
          console.log("si entro yea");
          this.dataAllGlobalEmailStatus=respuesta;
          this.datosGlobalsEmails = respuesta.dataEvents[0];

          this.dataSource[0].aviso1=this.datosGlobalsEmails.aviso1.countDelivered;;
          this.dataSource[1].aviso1=this.datosGlobalsEmails.aviso1.countProcessing;
          this.dataSource[2].aviso1=this.datosGlobalsEmails.aviso1.countNoDelivered;
          this.dataSource[0].aviso2=this.datosGlobalsEmails.aviso2.countDelivered;
          this.dataSource[1].aviso2=this.datosGlobalsEmails.aviso2.countProcessing;
          this.dataSource[2].aviso2=this.datosGlobalsEmails.aviso2.countNoDelivered;
          this.dataSource[0].invitacion=this.datosGlobalsEmails.lanzamiento.countDelivered;
          this.dataSource[1].invitacion=this.datosGlobalsEmails.lanzamiento.countProcessing;
          this.dataSource[2].invitacion=this.datosGlobalsEmails.lanzamiento.countNoDelivered;
          this.dataSource[0].recor1=this.datosGlobalsEmails.recordatorio1.countDelivered;
          this.dataSource[1].recor1=this.datosGlobalsEmails.recordatorio1.countProcessing;
          this.dataSource[2].recor1=this.datosGlobalsEmails.recordatorio1.countNoDelivered;
          this.dataSource[0].recor2=this.datosGlobalsEmails.recordatorio2.countDelivered;
          this.dataSource[1].recor2=this.datosGlobalsEmails.recordatorio2.countProcessing;
          this.dataSource[2].recor2=this.datosGlobalsEmails.recordatorio2.countNoDelivered;
          // if (tipo==2) {
            Swal.close();
            this.openSuccessSnackBar(this.translateSrv.instant('HISTORIAL_MAILS.MODALES.SUCC_UPDAT_HIST_EMA'),'');
          // }
        }else{
          if (respuesta.message=="SQL error") {
            Swal.fire({
              icon: 'warning',
              title: this.translateSrv.instant('HISTORIAL_MAILS.MODALES.WAR_SQL_ERROR'),
              confirmButtonText: this.translateSrv.instant('CIERRE.ALERT.OK'),
            });
          }
        }
      });

  }

  tipoCorreosMostrar( element:any, tipoCorreo?:string){
    this.cargando=1;
    // console.log('tipoCorreo',tipoCorreo);
    // console.log('element',element);
    let titutoTable:string;

if (element.status=="enviados" && tipoCorreo=="aviso1" ) {
    this.colorIconStatus="#41CF16";
  this.tipoCorreoBuscar=3;
  this.statusCorreoBuscar='delivered';
  this.tituloCabezeraEmails=this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TITU_AV1_DELIV');
}else if (element.status=="procesando" &&tipoCorreo=="aviso1" ) {
  this.tipoCorreoBuscar=3;
  this.tituloCabezeraEmails=this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TITU_AV1_PROCC');
  this.statusCorreoBuscar='processed';
  this.colorIconStatus="#999AA0";
}else if (element.status=="error" && tipoCorreo=="aviso1" ) {
  this.colorIconStatus="#F40D0D";
  this.tipoCorreoBuscar=3;
  this.tituloCabezeraEmails=this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TITU_AV1_N_DELIV');
    this.statusCorreoBuscar='notDelivered';
}else if (element.status=="enviados"&&tipoCorreo=="aviso2" ) {
    this.colorIconStatus="#41CF16";
  this.statusCorreoBuscar='delivered';
  this.tituloCabezeraEmails=this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TITU_AV2_DELIV');
  this.tipoCorreoBuscar=4;
}else if ( element.status=="procesando"&&tipoCorreo=="aviso2") {
  this.tituloCabezeraEmails=this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TITU_AV2_PROCC');
  this.statusCorreoBuscar='processed';
  this.colorIconStatus="#999AA0";
  this.tipoCorreoBuscar=4;
}else if (element.status=="error"&&tipoCorreo=="aviso2" ) {
  this.colorIconStatus="#F40D0D";
  this.tituloCabezeraEmails=this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TITU_AV2_N_DELIV');
    this.statusCorreoBuscar='notDelivered';
  this.tipoCorreoBuscar=4;
}else if (element.status=="enviados"&&tipoCorreo=="invitacion" ) {
    this.colorIconStatus="#41CF16";
  this.tituloCabezeraEmails=this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TITU_INV_DELIV');
  this.tipoCorreoBuscar=1;
  this.statusCorreoBuscar='delivered';
}else if (element.status=="procesando"&&tipoCorreo=="invitacion" ) {
  this.tituloCabezeraEmails=this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TITU_INV_PROCC');
  this.statusCorreoBuscar='processed';
  this.colorIconStatus="#999AA0";
  this.tipoCorreoBuscar=1;
}else if ( element.status=="error"&&tipoCorreo=="invitacion") {
  this.colorIconStatus="#F40D0D";
  this.tituloCabezeraEmails=this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TITU_INV_N_DELIV');
    this.statusCorreoBuscar='notDelivered';
  this.tipoCorreoBuscar=1;
}else if (element.status=="enviados"&&tipoCorreo=="recor1") {
    this.colorIconStatus="#41CF16";
  this.statusCorreoBuscar='delivered';
  this.tituloCabezeraEmails=this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TITU_REC1_DELIV');
  this.tipoCorreoBuscar=6
  this.statusCorreoBuscar='delivered';
}else if (element.status=="procesando"&&tipoCorreo=="recor1" ) {
  this.tituloCabezeraEmails=this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TITU_REC1_PROCC');
  this.statusCorreoBuscar='processed';
  this.colorIconStatus="#999AA0";
  this.tipoCorreoBuscar=6
}else if (element.status=="error"&&tipoCorreo=="recor1") {
  this.colorIconStatus="#F40D0D";
  this.tituloCabezeraEmails=this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TITU_REC1_N_DELIV');
  this.statusCorreoBuscar='notDelivered';
  this.tipoCorreoBuscar=6
}else if (element.status=="enviados"&&tipoCorreo=="recor2") {
    this.colorIconStatus="#41CF16";
  this.tituloCabezeraEmails=this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TITU_REC2_DELIV');
  this.tipoCorreoBuscar=7;
  this.statusCorreoBuscar='delivered';
}else if (element.status=="procesando"&&tipoCorreo=="recor2") {
  this.tituloCabezeraEmails=this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TITU_REC2_PROCC');
  this.statusCorreoBuscar='processed';
  this.colorIconStatus="#999AA0";
  this.tipoCorreoBuscar=7;
}else if ( element.status=="error"&&tipoCorreo=="recor2") {
  this.colorIconStatus="#F40D0D";
  this.tituloCabezeraEmails=this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TITU_REC2_N_DELIV');
    this.statusCorreoBuscar='notDelivered';
  this.tipoCorreoBuscar=7;
}


this.surveyServ.getInfoEventGralColabEmail(this.datosEmpresaProducto.idProducto,this.tipoCorreoBuscar,this.statusCorreoBuscar).subscribe((respuesta:any) => {
  // console.log("getInfoEventGralColabEmail:",respuesta);
  this.cargando=2;
  this.datosTablaTipoCorreoInfo = respuesta.colaboradoresStatus;
  this.datosTablaTipoCorreoInfo.forEach(timestamp => {
    var dateString = moment.unix(timestamp.TimeStamp );
    timestamp.fechaActualNueva=dateString;
  });
  this.datosTablaTipoCorreo = new MatTableDataSource<any>(this.datosTablaTipoCorreoInfo);
  setTimeout(() => this.datosTablaTipoCorreo.sort  = this.sort );
  setTimeout(() => this.datosTablaTipoCorreo.paginator  = this.paginator );
});



  }
  verConfigResult(datos:any){
    console.log('datos',datos);

    const dialogRef = this.dialog.open(ModalesComponent,
      {
      width: '85%',
      height: '97%',
      panelClass: ['animate__animated','animate__slideInLeft'] ,
      data: {
        tipoCorreo: this.tipoCorreoBuscar,
        datosColaborador:datos,
        productoId:this.datosEmpresaProducto.idProducto,
        statusCorreo:this.statusCorreoBuscar,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  applyFilter(filterValue: string) {
  this.datosTablaTipoCorreo.filter = filterValue.trim().toLowerCase();
  // console.log('this.dataSource.filter',this.datosTablaTipoCorreo.filter);

}

exportTable(){
  // Swal.showLoading()
  var wb = XLSX.utils.book_new();
  wb.Props = {
    // Title: this.translateSrv.instant("COLABORADORES.EXCEL.TITUARCHIVO"),
    Title: 'sdcmask',
    Subject: 'CULTURAL GO',
    Author: 'ITBM',
    CreatedDate: new Date()
  };
  wb.SheetNames.push('hoja');
  var ws_data = [];
  let nombresColumnas:string[] = [];
  backInter.CLAVES_COLUMNASEMAILGRAL.forEach( (nombre) => {
    switch(nombre){
      case 'name': nombresColumnas.push(this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TH_2')); break;
      case 'email': nombresColumnas.push(this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TH_3')); break;
      case 'status': nombresColumnas.push(this.translateSrv.instant('EMAI_LOG.TABLA_COLAB.TH_1')); break;
    }
  });
  console.log("Colaboradores")
  ws_data.push(nombresColumnas);
  this.datosTablaTipoCorreoInfo.forEach( (info) => {
    let datosColaboradores:any[] = [];
    backInter.CLAVES_COLUMNASEMAILGRAL.forEach( (nombre) => {
      switch(nombre){
        case 'name': datosColaboradores.push(info.UserName); break;
        case 'email': datosColaboradores.push(info.EMail); break;
        case 'status': datosColaboradores.push(info.Event); break;
      }
    });
    ws_data.push(datosColaboradores);
    // console.log(ws_data);
  });
  var ws = XLSX.utils.aoa_to_sheet(ws_data);
  wb.Sheets['hoja'] = ws;
  var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
  var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
  var view = new Uint8Array(buf);  //create uint8array as viewer
  for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet
  // saveAs(new Blob([buf],{type:"application/octet-stream"}), `${this.translateSrv.instant("COLABORADORES.EXCEL.TITUARCHIVO")}.xlsx`);
  saveAs(new Blob([buf],{type:"application/octet-stream"}), `${'email'}.xlsx`);
  // Swal.close();
}

actualizarHistorial(){

  this.modalEnviandoCorreos();
  this.getAllGlobalsEmailStatus(this.datosEmpresaProducto.idProducto,2);
}

modalEnviandoCorreos(){
  Swal.fire({
    title: this.translateSrv.instant('HISTORIAL_MAILS.MODALES.UPDAT_HIST_EMA'),
    allowOutsideClick: false,
    showConfirmButton: false,
    imageUrl: localStorage.getItem('urlGifBroker'),
    imageWidth: 100,
    imageHeight: 60,
    // didOpen: () => {
    //   Swal.showLoading()
    // }
  });
}
openSuccessSnackBar(message: string, action: string) {
   this.snackBar.open(message, action, {
      duration: 1000,
      panelClass: ['background-success']
   });
}
}
